import { AxiosResponse } from "axios";

export const getAPIData = (promise: Promise<AxiosResponse>) => {
  return promise.then((res) => {
    return res.data;
  });
};
